export { default, default as Paragraph } from './Paragraph'
export { default as paragraphTheme } from './themes/Paragraph.theme'
export * as ParagraphStyles from './styles/Paragraph.style'

export type { ParagraphProps } from './Paragraph.types'
export type { AppearanceKeys, ParagraphTheme } from './themes/Paragraph.theme.types'
export type { StyledParagraphProps } from './styles/Paragraph.style.types'
